import { phpRequest } from "./phpRequest";

export const uploadNewDevicesAPI = (companyId, excelFile) => {
  let formData = new FormData();
  formData.append("company_id", companyId);
  formData.append("spreadsheet", excelFile);

  return phpRequest.post("/devices/upload-new-devices", formData);
};
